export default __webpack_public_path__ + "static/3-67fd4549fe936a92467e123ea9ef4693.jpeg";